import { render, staticRenderFns } from "./LogoGato.vue?vue&type=template&id=bad054de&scoped=true"
import script from "./LogoGato.vue?vue&type=script&lang=js"
export * from "./LogoGato.vue?vue&type=script&lang=js"
import style0 from "./LogoGato.vue?vue&type=style&index=0&id=bad054de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad054de",
  null
  
)

export default component.exports